var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.params.label))]),(_vm.params.subLabel)?_c('br'):_vm._e(),(_vm.params.subLabel)?_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.params.subLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }